import React, { useState } from 'react';
import { useAuth } from './context/AuthContext';

export default function ResetPassword({ mode = 'setup' }) {
  const { updatePassword } = useAuth();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const isRecovery = mode === 'recovery';
  const title = isRecovery ? 'Set a new password' : 'Set your password';
  const subtitle = isRecovery
    ? 'Choose a secure password for your account.'
    : 'Welcome to Tikix PMS Tracker. Create your password to finish joining, then continue to the app.';
  const submitLabel = isRecovery ? 'Update password' : 'Save password & continue';
  const submittingLabel = isRecovery ? 'Updating password…' : 'Saving password…';

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    if (password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setSubmitting(true);
    try {
      await updatePassword(password);
    } catch (err) {
      setError(err.message || 'Unable to update your password.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white border border-gray-200 rounded-2xl shadow-sm p-8">
        <div className="flex items-center space-x-4 mb-6">
          <img src="/tikix-logo.png" alt="Tikix" className="w-28 h-auto" />
          <div>
            <h1 className="text-lg font-black text-purple-900 tracking-tight">
              {title}
            </h1>
            <p className="text-xs text-gray-500 font-medium">{subtitle}</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-bold text-gray-500 mb-1">
              {isRecovery ? 'New password' : 'Password'}
            </label>
            <input
              type="password"
              required
              minLength={8}
              autoComplete="new-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              className="w-full px-4 py-2.5 border border-gray-300 rounded-xl text-sm focus:ring-2 focus:ring-purple-500 focus:outline-none"
              placeholder="At least 8 characters"
            />
          </div>

          <div>
            <label className="block text-xs font-bold text-gray-500 mb-1">
              Confirm password
            </label>
            <input
              type="password"
              required
              minLength={8}
              autoComplete="new-password"
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
              className="w-full px-4 py-2.5 border border-gray-300 rounded-xl text-sm focus:ring-2 focus:ring-purple-500 focus:outline-none"
            />
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 text-xs font-medium rounded-xl px-3 py-2">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={submitting}
            className="w-full bg-purple-600 text-white px-5 py-3 rounded-xl text-sm font-bold hover:bg-purple-700 shadow-sm disabled:opacity-60"
          >
            {submitting ? submittingLabel : submitLabel}
          </button>
        </form>
      </div>
    </div>
  );
}
